var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports", "./analytics", "./customDesign", "./debounce", "./design", "./device", "./mobileProductPictures", "./resize", "./util", "./viewport"], function (require, exports, analytics_1, customDesign_1, debounce_1, design_1, device_1, mobileProductPictures_1, resize_1, util_1, viewport_1) {
    "use strict";
    exports.__esModule = true;
    var _centerFit = function (size) { return function (box) { return ({ top: Math.max(0, (box.Height - size.Height) / 2), left: Math.max(0, (box.Width - size.Width) / 2) }); }; };
    var centerFit = util_1.uncurry(_centerFit);
    var centerFitCurtain = function ($curtain) {
        var $window = $(window);
        var windowSize = { Width: $window.width(), Height: $window.height() };
        var maxSize = design_1.scaleSize(windowSize, 0.96);
        var curtainSize = { Width: parseFloat($curtain.attr('width')), Height: parseFloat($curtain.attr('height')) };
        var fitSize = util_1.minVector(curtainSize, design_1.fitBoundingBox(curtainSize, maxSize));
        var curtainPos = centerFit(fitSize, windowSize);
        console.log("centerFit windowSize = " + JSON.stringify(windowSize));
        $curtain.css({ left: curtainPos.left + "px", top: curtainPos.top + "px" });
    };
    var fitButton = function ($button) {
        var offsetY = viewport_1.offsetYIntoViewPort($button).Y;
        if (offsetY > 0) {
            var transform = resize_1.getTransform($button);
            transform.tY = transform.tY - offsetY;
            $button.css({ transform: resize_1.transformCss(transform) });
        }
    };
    var onResize = debounce_1["default"](function () {
        var $tooltip = $('#scroll-tooltip');
        var $button = $('#camera--trigger');
        if (viewport_1.shouldShowScrollTip($('#liveview-popup')[0])) {
            if (!$tooltip.is(':visible')) {
                $tooltip.show();
                fitButton($button);
            }
        }
        else {
            if ($tooltip.is(':visible')) {
                $tooltip.hide();
                fitButton($button);
            }
        }
    }, 100);
    var onOrientationChange = function ($curtain) {
        if ($('#liveview-popup').hasClass('show')) {
            $curtain.css('transform', 'none');
            centerFitCurtain($curtain);
            setTimeout(function () {
                var $button = $('#camera--trigger');
                $button.removeAttr('style');
                fitButton($button);
            }, 200);
        }
    };
    function turnOffCamera() {
        try {
            var cameraView = $("#camera--view")[0];
            var stream = cameraView.srcObject;
            stream.getTracks()[0].stop();
            cameraView.srcObject = null;
        }
        catch (ex) {
        }
        $('canvas#liveViewCurtain').css('transform', 'none');
        $('#camera--trigger').removeAttr('style');
    }
    function hideMobileLiveView($popup) {
        turnOffCamera();
        $popup.toggleClass('show', false);
    }
    function mobileLiveViewWithCamera() {
        var $popup = $('#liveview-popup');
        $popup.toggleClass('show', true);
        var $curtain = $popup.find('canvas#liveViewCurtain');
        if ($curtain.attr('draggable') !== 'true') {
            $(window).on('resize', function () { return onResize(); });
            $(window).on('orientationchange', function () {
                $curtain.css('transform', 'none');
                setTimeout(function () { return onOrientationChange($curtain); }, 100);
            });
            $curtain.attr('pinchzoom', 'true');
            $curtain.on('pinchzoom', function (_, pe) {
                var _a = resize_1.getTransform($curtain), scaleX = _a.scaleX, skewX = _a.skewX, skewY = _a.skewY, tX = _a.tX, tY = _a.tY;
                var originScale = parseFloat($curtain.data('scaleOrigin')) || scaleX;
                if (!$curtain.data('scaleOrigin')) {
                    $curtain.data('scaleOrigin', originScale);
                }
                var pinchzoom = pe.pinchzoom;
                $curtain.css('transform', resize_1.transformCss({
                    scaleX: originScale * pinchzoom,
                    scaleY: originScale * pinchzoom,
                    skewX: skewX, skewY: skewY, tX: tX, tY: tY
                }));
            }).on('pinchzoomend', function () {
                $curtain.removeData('scaleOrigin');
            });
            resize_1.resizable($curtain, function (_, nextX, nextY) {
                var _a = resize_1.getTransform($curtain), scaleX = _a.scaleX, scaleY = _a.scaleY, skewX = _a.skewX, skewY = _a.skewY, tX = _a.tX, tY = _a.tY;
                var _b = $curtain.data('dragstart') || { x: undefined, y: undefined }, x = _b.x, y = _b.y;
                if (x === undefined || y === undefined) {
                    return;
                }
                if (!$curtain.data('dragOrigin')) {
                    $curtain.data('dragOrigin', { x: x - tX, y: y - tY });
                }
                var _c = $curtain.data('dragOrigin'), ox = _c.x, oy = _c.y;
                $curtain.css('transform', resize_1.transformCss({
                    tX: nextX - ox,
                    tY: nextY - oy,
                    skewX: skewX,
                    skewY: skewY,
                    scaleX: scaleX,
                    scaleY: scaleY
                }));
            });
        }
        turnOnCamera().then(function (ok) {
            if (!ok) {
                hideMobileLiveView($popup);
                alert("Can't access camera");
            }
        });
        if ($popup.find('.close-button').length == 0) {
            $popup.append('<div class="close-button"></div>');
        }
        $popup.find('.close-button').click(hideMobileLiveView.bind(null, $popup));
    }
    function turnOnCamera() {
        analytics_1["default"]('liveview', 'open');
        var constraints = { video: { facingMode: "environment" }, audio: false };
        var cameraView = $("#camera--view")[0];
        var result = $.Deferred();
        navigator.mediaDevices
            .getUserMedia(constraints)
            .then(function (stream) {
            analytics_1["default"]('liveview', 'opened');
            var mediaTrack = stream.getTracks()[0];
            cameraView.srcObject = stream;
            result.resolve(true);
        }, function (err) {
            analytics_1["default"]('liveview', 'failedGetUserMedia');
            result.resolve(false);
        })["catch"](function (error) {
            console.error("Oops. Something is broken.", error);
            analytics_1["default"]('liveview', 'failedStream');
            result.resolve(false);
        });
        setTimeout(function () { return onOrientationChange($('canvas#liveViewCurtain')); }, 500);
        $("#camera--trigger").click(function () {
            analytics_1["default"]('liveview', 'takepicture');
            var customerSceneBackgroundCanvas = document.querySelector("#customerSceneBackground");
            var $cameraView = $(cameraView);
            var viewWidth = $cameraView.width();
            var viewHeight = $cameraView.height();
            var videoWidth = cameraView.videoWidth;
            var videoHeight = cameraView.videoHeight;
            var videoFit = design_1.fitBoundingBox({ Width: viewWidth, Height: viewHeight }, { Width: videoWidth, Height: videoHeight });
            customerSceneBackgroundCanvas.width = cameraView.videoWidth;
            customerSceneBackgroundCanvas.height = cameraView.videoHeight;
            var videoTopLeft = centerFit(videoFit, { Width: videoWidth, Height: videoHeight });
            customerSceneBackgroundCanvas.getContext("2d").drawImage(cameraView, 0, 0);
            var $liveCurtain = $('#liveViewCurtain');
            var scaleX = resize_1.getTransform($liveCurtain).scaleX;
            var _liveCurtainBox = __assign({}, $liveCurtain.position(), { width: $liveCurtain.width(), height: $liveCurtain.height() });
            var liveCurtainBox = Object.keys(_liveCurtainBox).reduce(function (cur, key) {
                var _a;
                return (__assign({}, cur, (_a = {}, _a[key] = (videoFit.Width / viewWidth) * scaleX * _liveCurtainBox[key], _a)));
            }, {});
            var cameraBox = { top: 0, left: 0, width: cameraView.videoWidth, height: cameraView.videoHeight };
            $(customerSceneBackgroundCanvas).data('layout', { liveCurtainBox: liveCurtainBox, videoBox: cameraBox, offset: videoTopLeft });
            var $scene = mobileProductPictures_1.injectLiveViewScene($('.photoshow'));
            turnOffCamera();
            $('#camera--trigger').unbind();
            $('#liveview-popup').toggleClass('show', false);
            customDesign_1.onCustomerSceneBackgroundChange().then(function () {
                var index = $scene.parent().index();
                $('.photoshow .paging').touchSlider('current', index);
            });
        });
        return result.promise();
    }
    function mobileLiveView() {
        var $show = $('.photoshow');
        $('.canvasDiv .icon-close').off('click').on('click', function () {
            analytics_1["default"]('liveview', 'removepicture');
            mobileProductPictures_1.ejectLiveViewScene($show);
        });
        $show.touchSlider('exitFullScreen')
            .then(device_1.checkCamera)
            .then(function (result) {
            if (result.hasCamera) {
                mobileLiveViewWithCamera();
            }
            else {
                analytics_1["default"]('liveview', 'nocamera');
                if (device_1.isFacebookInAppBrowser()) {
                    var tipText = "Open link in " + (device_1.isAndroid() ? 'browser' : 'Safari') + " for live view";
                    alert(tipText);
                }
                else {
                    if (result && result.error && result.error.message)
                        alert(result.error.message);
                }
            }
        });
    }
    exports.mobileLiveView = mobileLiveView;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/liveView.js
// module id = 88
// module chunks = 0